import styled from 'styled-components';

export const MobileTitlesTable = styled.table`
  width: 30%;
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.07),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.11);
  position: relative;
  border-collapse: collapse;
`;

export const MobileDataTable = styled.table`
  width: 800px;
  height: 100%;
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.07),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.11);
  position: absolute;
  border-collapse: collapse;
`;

export const MobileTimesheetsTablesWrapper = styled.div`
  width: 100%;
  display: flex;
`;

export const MobileTimesheetsScroll = styled.div`
  width: 80%;
  position: relative;
  overflow-x: scroll;
  overflow-y: hidden;
  ::-webkit-scrollbar {
    height: 3px;
  }
`;
